export default function getIdfromPath(index = 2) {
    const pathSplit = window.location.pathname.split("/");
    const id = pathSplit[pathSplit.length - index];
    return id;
}